<template>
  <div class="container-withdraw-method" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.BaseCommon.k106') }}</span>
        </template>
        <template #right>
          <img class="right-nav" :src="locaFlag | imgPath" alt="" />
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <span class="tit">{{ $t('lang.BaseCommon.k101') }}</span>
      <div
        class="method"
        :class="{ methidDis: minPrice && minPrice < item.minDollarAmount }"
        v-for="item in withdrawMethodList"
        :key="item"
        @click="item.flag && handleChooseAccount(item)"
      >
        <div class="method-ifSupport" :class="{ ifSupport: !item.ifSupport }" @click="handleIfSupport"></div>
        <img :src="item.icon | imgPath" alt="" />
        <span class="line"></span>
        <div class="bind">
          <div class="name">
            <span>{{ item.withdrawalMethod }}</span>
            <div class="tags-wrapper">
              <div v-if="item.desc" class="fee">
                <span>{{ item.desc }}</span>
              </div>
              <!-- 是否支持 instant -->
              <div v-if="item.ifInstantPay" class="fee">
                <span>{{ $t('lang.WithdrawalBind.k001') }}</span>
              </div>
            </div>
          </div>
          <div class="bind-btn">
            <img v-if="!item.ifSupport" src="@/assets/packageAssets/views/P1_Girls/WithdrawalBind/default/icon_lock.png" alt="" />
            <template v-if="item.withdrawalMethod === 'USDT(BINANCE)'">
              <van-popover
                v-model="tipsVisible"
                trigger=""
                theme="dark"
                :placement="rtlLangs.includes($i18n.locale) ? 'bottom-start' : 'bottom-end'"
                @select="tipsVisible = false"
              >
                <div class="tips_wrapper">{{ $t('lang.WithdrawalBind.k003') }}</div>
                <template #reference>
                  <span
                    class="span change-btn"
                    v-if="item.flag == 'true'"
                    @click.stop="
                      handleChangeAccount(
                        item.icon,
                        item.withdrawalMethod,
                        locaFlag,
                        locaCode,
                        walletType,
                        item.minDollarAmount,
                        'change',
                        item.canModify
                      )
                    "
                  >
                    {{ $t('lang.BaseCommon.k008') }}
                    <van-icon class="arrow" name="arrow" />
                  </span>
                  <span
                    class="span"
                    v-else
                    @click="handleBindAccount(item.icon, item.withdrawalMethod, locaFlag, locaCode, walletType, item.minDollarAmount)"
                  >
                    {{ $t('lang.BaseCommon.k004') }}
                    <van-icon class="arrow" name="arrow" />
                  </span>
                </template>
              </van-popover>
            </template>
            <template v-else>
              <span
                class="span change-btn"
                v-if="item.flag == 'true'"
                @click.stop="
                  handleChangeAccount(
                    item.icon,
                    item.withdrawalMethod,
                    locaFlag,
                    locaCode,
                    walletType,
                    item.minDollarAmount,
                    'change',
                    item.canModify
                  )
                "
              >
                {{ $t('lang.BaseCommon.k008') }}
                <van-icon class="arrow" name="arrow" />
              </span>
              <span
                class="span"
                v-else
                @click="handleBindAccount(item.icon, item.withdrawalMethod, locaFlag, locaCode, walletType, item.minDollarAmount)"
              >
                {{ $t('lang.BaseCommon.k004') }}
                <van-icon class="arrow" name="arrow" />
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <c-confirm :headline="headline" :title="title" :showDiaC="showDiaConfirm" :oneShow="oneShow"></c-confirm>
  </div>
</template>

<script>
import CConfirm from '@/components/CConfirm'
import { apiWithdrawMethod } from '@/api/imee.js'

export default {
  components: { CConfirm },
  props: {},
  data() {
    const query = this.$route.query

    let tempAccounts = null
    try {
      tempAccounts = query.accounts ? JSON.parse(query.accounts) : null
    } catch (err) {
      tempAccounts = null
    }

    return {
      barHeight: query.statusBarHeight || 38,
      withdrawMethodList: [],
      locaFlag: query.locaFlag,
      locaCode: query.locaCode,
      walletType: query.walletType,
      accounts: tempAccounts,
      cfgId: null,
      minPrice: query.price || null,
      tipsVisible: false,
      // 提示的文案
      showDiaConfirm: false,
      headline: this.$t('lang.WithdrawalBind.k005'),
      title: this.$t('lang.WithdrawalBind.k004'),
      oneShow: true,

      // 提现页面传过来的选好的价格
      seletePrice: query.price || null,

      feeUsdt: query.feeUsdt || null,
    }
  },
  created() {},
  mounted() {
    this.getWithdrawMethod()
  },
  methods: {
    getWithdrawMethod() {
      apiWithdrawMethod().then((res) => {
        if (res) {
          const resData = res || []
          if (Array.isArray(resData)) {
            this.withdrawMethodList = resData
            this.withdrawMethodList.forEach((item1) => {
              if (Array.isArray(this.accounts)) {
                this.accounts.forEach((item2) => {
                  if (item1.withdrawalMethod == item2.withdrawalMethod) {
                    item1.flag = 'true'
                  }
                })
              }
            })
            const targetItem = resData.find((v) => v.withdrawalMethod === 'USDT(BINANCE)') || {}
            if (targetItem.ifNeedUpdate && !localStorage.getItem('ifNeedUpdate')) {
              this.$nextTick(() => {
                this.tipsVisible = true
              })
            }
          }
        }
      })
    },

    // 选择支付账号
    handleChooseAccount(item) {
      const params = {
        withdrawalMethod: item.withdrawalMethod,
        icon: item.icon,
        minPrice: item.minDollarAmount,
        walletType: this.walletType,
        price: this.seletePrice,
        feeUsdt: this.feeUsdt,
      }
      sessionStorage.setItem('bind-withdrawal', JSON.stringify(params))
      this.goPrevious()
    },

    // 绑定账号页面
    handleBindAccount(icon, withdrawalMethod, locaFlag, locaCode, walletType, minDollarAmount) {
      localStorage.setItem('ifNeedUpdate', 'true')
      this.$router.push({
        path: 'withdrawal-account',
        query: {
          icon,
          withdrawalMethod,
          locaFlag,
          locaCode,
          walletType,
          minDollarAmount,
        },
      })
    },

    // 去修改
    handleChangeAccount(icon, withdrawalMethod, locaFlag, locaCode, walletType, minDollarAmount, change, flag) {
      localStorage.setItem('ifNeedUpdate', 'true')
      if (flag) {
        this.$router.push({
          path: 'withdrawal-account',
          query: {
            icon,
            withdrawalMethod,
            locaFlag,
            locaCode,
            walletType,
            minDollarAmount,
            change,
          },
        })
      } else {
        this.$client.showToast(this.$t('lang.WithdrawalBind.k002'))
      }
    },

    // 置灰提示
    handleIfSupport() {
      this.showDiaConfirm = true
    },
    cancelAgain() {
      this.showDiaConfirm = false
    },
  },
  watch: {},
  computed: {},
}
</script>

<style lang="scss" scoped>
.container-withdraw-method {
  width: 100%;
  min-height: 100vh;
  background: #f7f6f9;
  .main {
    padding: 0 16px;
    .tit {
      display: block;
      width: 100%;
      margin: 20px 0;
      text-align: center;
      font-size: 16px;
      font-family: 'Inter-Medium';
      font-weight: 500;
      color: #333333;
    }
    .method {
      position: relative;
      height: 70px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 16px;
      > img {
        height: 24px;
      }
      .line {
        display: block;
        height: 24px;
        margin: 0 10px;
        color: #000 !important;
        border-left: 1px solid #ccc;
      }
      .bind {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .name {
          font-size: 12px;
          font-family: 'Inter-Medium';
          font-weight: 500;
          color: #333333;
          .tags-wrapper {
            width: fit-content;
            height: fit-content;
            display: flex;
            align-items: center;
            justify-content: center;
            .fee {
              margin-top: 5px;
              margin-right: 8px;
              text-align: center;
              border-radius: 2px;
              border: 1px solid #ff2639;
              > span {
                display: block;
                font-size: 12px;
                transform: scale(0.8);
                transform-origin: center center;
                color: #ff2639;
              }
            }
          }
        }
        .bind-btn {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: 'Inter-Regular';
          font-weight: 400;
          color: #999999;
          > img {
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
          .arrow {
            font-size: 14px;
          }
          .span {
            height: 100%;
            line-height: 40px;
          }
          .change-btn {
            color: #9743f3;
          }
        }
      }
    }
    .methidDis {
      filter: grayscale(100%);
      pointer-events: none;
      background-color: #f1f3f4;
    }
    .method-ifSupport {
      position: absolute;
      z-index: -100;
      width: 0;
      height: 0;
      border-radius: 10px;
      background-color: rgba(0, 0, 0, 0);
    }
    // 等级达不到会置灰上锁 点击会有提示
    .ifSupport {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      background-color: rgba(0, 0, 0, 0.14);
    }
  }
}

.container-withdraw-method.kiko {
  width: 100%;
  min-height: 100vh;
  background: #f7f6f9;
  .main {
    padding: 0 16px;
    .tit {
      display: block;
      width: 100%;
      margin: 20px 0;
      text-align: center;
      font-size: 16px;
      font-family: 'Inter-Medium';
      font-weight: 500;
      color: #333333;
    }
    .method {
      position: relative;
      height: 70px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: 10px;
      margin-bottom: 16px;
      > img {
        height: 24px;
      }
      .line {
        display: block;
        height: 24px;
        margin: 0 10px;
        color: #000 !important;
        border-left: 1px solid #ccc;
      }
      .bind {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .name {
          font-size: 12px;
          font-family: 'Inter-Medium';
          font-weight: 500;
          color: #333333;
          .tags-wrapper {
            width: fit-content;
            height: fit-content;
            display: flex;
            align-items: center;
            justify-content: center;
            .fee {
              margin-top: 5px;
              margin-right: 8px;
              text-align: center;
              border-radius: 2px;
              border: 1px solid #ff2639;
              > span {
                display: block;
                font-size: 12px;
                transform: scale(0.8);
                transform-origin: center center;
                color: #ff2639;
              }
            }
          }
        }
        .bind-btn {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: 'Inter-Regular';
          font-weight: 400;
          color: #999999;
          > img {
            display: inline-block;
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
          .arrow {
            font-size: 14px;
          }
          .span {
            height: 100%;
            line-height: 40px;
          }
          .change-btn {
            color: #545455;
          }
        }
      }
    }
    .methidDis {
      filter: grayscale(100%);
      pointer-events: none;
      background-color: #f1f3f4;
    }
    .method-ifSupport {
      position: absolute;
      z-index: -100;
      width: 0;
      height: 0;
      border-radius: 10px;
      background-color: rgba(0, 0, 0, 0);
    }
    // 等级达不到会置灰上锁 点击会有提示
    .ifSupport {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      background-color: rgba(0, 0, 0, 0.14);
    }
  }
}

.tips_wrapper {
  background-color: #3a2544;
  padding: 4px 10px;
  line-height: 24px;
  font-size: 13px;
}

::v-deep .right-nav {
  width: auto;
  height: 20px;
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-withdraw-method {
    .main {
      .method {
        .bind {
          .name {
            .tags-wrapper {
              .fee {
                margin-right: 0;
                margin-left: 8px;
              }
            }
          }
          .bind-btn {
            .arrow.van-icon {
              transform: rotateY(180deg);
            }
          }
        }
      }
    }
  }
}
</style>
